import React from "react"
import _ from "lodash"
import axios from "axios"
import { JSUtils } from "@utils"
import * as ServiceAPI from "@services"
import UserService from "../../../services/UserService"
import { getAddOnHeaders, getAddOnHeadersGlobal } from "../../../utils/url"
const { API_BASE_URL, KC_API_BASE_URL } = ServiceAPI

const GET_TURNSTILE_API_SERVICE = `${API_BASE_URL}/sdc/api/sdc/getturnstiledetails?`
const GET_TURNSTILE_API_SERVICE_TEST = `${API_BASE_URL}/sdc/api/sdc/getturnstiledetails`
const GET_TURNSTILE_DETAILS_BY_ID = `${API_BASE_URL}/sdc/api/sdc/getturnstile?`
const GET_TURNSTILEID = `${KC_API_BASE_URL}/api/kc/getid?`
const CREATE_TURNSTILE_API_SERVICE = `${API_BASE_URL}/sdc/api/sdc/createturnstile`
const EDIT_TURNSTILE_API_SERVICE = `${API_BASE_URL}/sdc/api/sdc/updateturnstile`
const DELETE_TURNSTILE = `${API_BASE_URL}/sdc/api/sdc/deleteturnstile`

const MAPPED_DEVICES_MSG = "Devices mapped. Cannot be deleted."

const getDeleteErrorMessage = (error) => {
  const msg = _.get(error, "response.data.message", "")
  if (/mapped/i.test(msg)) return MAPPED_DEVICES_MSG
  return msg || "Something went wrong, please try again."
}
const GET_LOCATIONDETAILS_BY_ID = `${API_BASE_URL}/store/api/stores/location`
const GET_MANUFACTURERS_API_SERVICE = `${API_BASE_URL}/sdc/api/sdc/getmanufacturers?`

const smartDeviceAxios = axios.create()

smartDeviceAxios.interceptors.request.use(
  async function (config) {
    const { isSaasView = false } = config || {}
    if (UserService.isLoggedIn()) {
      if (UserService.isAuthExpired() === true) {
        const myData = await UserService.updateRefreshToken()
        if (myData === true) {
          let mydataToken = UserService.getToken((res) => {
            return res
          })
          localStorage.setItem("token", mydataToken)
          config.headers["realm-id"] = localStorage.getItem("X-KC-Realm-ID")
          config.headers["Authorization"] = "Bearer " + mydataToken
          let tenantId =
            localStorage.getItem("tenantId") === null
              ? ""
              : localStorage.getItem("tenantId")
          config.headers["X-Tenant-ID"] = tenantId
          config.headers["X-KC-Realm-ID"] = localStorage.getItem(
            "X-KC-Realm-ID"
          )
          config.headers["X-KC-Host"] = localStorage.getItem("X-KC-Host")
          JSUtils?.getConfigAddonHeaders(config)
          getAddOnHeadersGlobal(
            config,
            isSaasView ? "saas-view" : "normal-view"
          )
        } else {
          localStorage.clear()
          UserService.doLogout()
        }
      } else {
        let tenantId =
          localStorage.getItem("tenantId") === null
            ? ""
            : localStorage.getItem("tenantId")
        config.headers["X-Tenant-ID"] = tenantId
        config.headers["realm-id"] = localStorage.getItem("X-KC-Realm-ID")
        config.headers["X-KC-Realm-ID"] = localStorage.getItem("X-KC-Realm-ID")
        config.headers["X-KC-Host"] = localStorage.getItem("X-KC-Host")
        config.headers["Authorization"] =
          localStorage.getItem("token") === null
            ? ""
            : "Bearer " + localStorage.getItem("token")
        JSUtils?.getConfigAddonHeaders(config)
        getAddOnHeadersGlobal(config, isSaasView ? "saas-view" : "normal-view")
      }
    } else {
      localStorage.clear()
      UserService.doLogout()
    }

    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

async function turnstileApi(globalState = {}, locationId) {
  const {
    data,
    setLoading,
    setData,
    setPageData,
    setRowData,
    selection,
    setItems,
    gridState,
  } = globalState
  const dataState = {
    filter: {
      logic: "and",
      filters: [],
    },
    sort: [],
    take: 50,
    skip: 0,
  }
  const adopterFunction = (dataState, page, limit) => {
    let sort = dataState.sort.reduce((acc, o) => {
      acc[o.field] = o.dir === "asc" ? 1 : -1
      return acc
    }, {})
    return {
      page,
      limit,
      filter: dataState?.filter?.filters,
      sort,
    }
  }
  const page = Math.floor(
    (gridState.dataState.take + gridState.dataState.skip) /
      gridState.dataState.take
  )
  const limit = gridState.dataState.take
  setLoading(true)
  const body = adopterFunction(gridState.dataState, page, limit)
  let turnStileId = ""
  let turnstileName = ""
  let turnstileIp = ""
  let locnum = ""
  let installLocation = ""
  let turnstilePort = ""
  let coordinates = ""
  let entryGateType = ""
  let resetTime = ""
  let sortpara = "turnstileId"
  let sortvalue = -1

  body &&
    body.filter &&
    body.filter.length !== 0 &&
    body.filter.map((val) => {
      if (val.field && val.field === "turnstileId") {
        turnStileId = val.value
      }
      if (val.field && val.field === "entryGateType") {
        entryGateType = val.value
      }
      if (val.field && val.field === "turnstileName") {
        turnstileName = val.value
      }
      if (val.field && val.field === "")
        if (val.field && val.field === "turnstileIp") {
          turnstileIp = val.value
        }
      if (val.field && val.field === "installLocation") {
        installLocation = val.value
      }
      if (val.field && val.field === "locationNumber") {
        locnum = val.value
      }
      if (val.field && val.field === "turnstilePort") {
        turnstilePort = val.value
      }
      if (val.field && val.field === "coordinates") {
        coordinates = val.value
      }
      if (val.field && val.field === "resetTime") {
        resetTime = val.value
      }
    })

  if (body && body.sort && Object.values(body.sort).length > 0) {
    sortpara = Object.keys(body.sort)[0]
    if (Object.values(body.sort)[0] === 1) {
      sortvalue = 1
    } else {
      sortvalue = -1
    }
  }
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }

  try {
    const response = await smartDeviceAxios.post(
      GET_TURNSTILE_API_SERVICE_TEST,
      {
        locationId: locationId,
        sortpara: sortpara,
        sortvalue: sortvalue,
        itemcount: body.limit,
        pagenumber: body.page,
        filter: {
          turnstileId: turnStileId,
          turnstileName: turnstileName,
          turnstileIp: turnstileIp,
          installLocation: installLocation,
          turnstilePort: turnstilePort,
          entryGateType: entryGateType,
          coordinates: coordinates,
          resetTime: resetTime,
        },
      },
      {
        ...options,
      }
    )

    await setData(_.get(response, "data.data", []))
    await setPageData(_.get(data, "data.data.totalPages", {}))
    await setItems(_.get(response, "data.data.totalDocs"))
    let responseData = []
    let storeData = {}
    if (JSUtils.isEmpty(response.data) === false) {
      response &&
        response.data &&
        response.data.data &&
        response.data.data.turnstile &&
        response.data.data.turnstile.map((dataItem) => {
          dataItem._id = dataItem.turnstileId
          responseData.push(dataItem)
        })
      storeData = {
        data: responseData.map((dataItem, i) => {
          const { _id, updatedAt } = dataItem || {}
          const { dateString, monthString, yearString, timeString } =
            JSUtils.getDateKit(updatedAt) || {}

          let dataKit = {
            ...dataItem,
            updatedAt: `${dateString} ${monthString} ${yearString}, ${timeString}`,
          }

          return Object.assign(
            {
              selected: selection.selectedItems.includes(dataItem._id)
                ? true
                : false,
              inEdit: false,
            },
            dataKit
          )
        }),
        editID: null,
        defaultID: null,
      }
    }
    await setRowData(storeData)
    await setLoading(false)
  } catch (err) {
    await setLoading(false)
  }
}

async function createTurnstileApi(
  turnstileDetails,
  history,
  setAlertMessage,
  setAlert,
  setAlertType,
  setSmartDeviceApiSuccessToggle,
  setLoading,
  setEdit,
  userProfileDetails = ""
) {
  setLoading(true)
  try {
    const payload = {
      locationId: turnstileDetails.LocNum,
      turnstileId: turnstileDetails.turnstileID,
      turnstileIp: turnstileDetails.turnstileIP,
      installLocation: turnstileDetails.turnstileloc,
      coordinates: [
        Number(turnstileDetails.CoordinatesX),
        Number(turnstileDetails.CoordinatesY),
      ],
      turnstileName: _.trim(turnstileDetails?.turnstileName),
      locationType: turnstileDetails?.locationType,
      entryGateType: turnstileDetails?.entryGateType,
      manufacturer: turnstileDetails?.manufacturer,
    }
    if (turnstileDetails.entryGateType === "Turnstile") {
      payload.turnstilePort = Number(turnstileDetails.turnstileport)
      payload.resetTime = Number(turnstileDetails.ResetTime)
    }
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    const res = await smartDeviceAxios.post(
      CREATE_TURNSTILE_API_SERVICE,
      payload,
      {
        ...options,
      }
    )
    if (res && res?.data?.status === "success") {
      await setAlertMessage(res?.data?.message)
      await setAlert(true)
      await setAlertType("success")
      setTimeout(() => {
        history.push(
          `/${userProfileDetails?.roleType}/autonomous-store/sdc/entryorexitgate`
        )
      }, 2000)
      return true
    } else if (res && res.data.status === "failed") {
      await setAlertMessage(res?.data?.message)
      await setAlert(true)
      await setAlertType("error")
      await setLoading(false)
      await setEdit(true)
      return false
    } else {
      await setAlertMessage(res?.data?.message)
      await setAlert(true)
      await setAlertType("error")
      await setLoading(false)
      return false
    }
  } catch (error) {
    await setAlertMessage(error?.response?.data?.message)
    await setAlert(true)
    await setAlertType("error")
    await setLoading(false)
    await setEdit(true)
    return false
  }
}

async function getTurnstileDetailsByID(id, LocationNum) {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  const res = await smartDeviceAxios.get(
    GET_TURNSTILE_DETAILS_BY_ID + `locationId=${LocationNum}&turnstileId=` + id,
    {
      ...options,
    }
  )
  if (res) {
    return res
  } else {
    return false
  }
}

async function editTurnstileApi(
  turnstileDetails,
  history,
  setAlertMessage,
  setAlert,
  setAlertType,
  setLoading,
  setEdit = () => {}
) {
  setLoading(true)
  try {
    const payload = {
      // locationId1: turnstileDetails.prevLoc,
      locationId: turnstileDetails.LocNum,
      installLocation: turnstileDetails.turnstileloc,
      coordinates: [
        Number(turnstileDetails.CoordinatesX),
        Number(turnstileDetails.CoordinatesY),
      ],
      turnstileId: turnstileDetails.turnstileID,
      turnstileIp: turnstileDetails.turnstileIP,
      turnstileName: _.trim(turnstileDetails?.turnstileName),
      locationType: turnstileDetails?.locationType,
      entryGateType: turnstileDetails?.entryGateType,
      manufacturer: turnstileDetails?.manufacturer,
    }
    if (turnstileDetails.entryGateType === "Turnstile") {
      payload.turnstilePort = Number(turnstileDetails.turnstileport)
      payload.resetTime = Number(turnstileDetails.ResetTime)
    }
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    const res = await smartDeviceAxios.put(
      EDIT_TURNSTILE_API_SERVICE,
      payload,
      {
        ...options,
      }
    )
    if (res && res.data.status === "success") {
      setEdit(false)
      await setAlertMessage(res?.data?.message)
      await setAlert(true)
      await setAlertType("success")
      await setLoading(false)
      return true
    } else if (res && res.data.status === "failed") {
      setEdit(true)
      await setAlertMessage(res?.data?.message)
      await setAlert(true)
      await setAlertType("error")
      await setLoading(false)
      return false
    } else {
      setEdit(true)
      await setAlertMessage(res?.data?.message)
      await setAlert(true)
      await setAlertType("error")
      await setLoading(false)
      return false
    }
  } catch (error) {
    setEdit(true)
    await setAlertMessage(error?.response?.data?.message)
    await setAlert(true)
    await setAlertType("error")
    await setLoading(false)
    return false
  }
}

async function getTurnstileId(LocationNum) {
  const res = await smartDeviceAxios.get(
    GET_TURNSTILEID + `locationId=${LocationNum}&sdctype=kcedgedevice`
  )
  if (res) {
    return res
  } else {
    return false
  }
}

async function getLocationById(LocationNum) {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  let response = await smartDeviceAxios.get(
    GET_LOCATIONDETAILS_BY_ID + "/" + LocationNum,
    {
      ...options,
    }
  )
  let { status = "", data = {} } = response || {}
  let locationTypeList = []
  if (response?.data?.status === "success") {
    return response
  } else {
    return false
  }
}

async function deleteTurnstile(locationId, turnstileId) {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  const res = await smartDeviceAxios.delete(
    `${DELETE_TURNSTILE}?locationId=${locationId}&turnstileId=${turnstileId}`,
    {
      ...options,
    }
  )
  return res
}

async function deleteTurnstileApi(locationid, selectItems) {
  const turnstileId = Array.isArray(selectItems) ? selectItems[0] : selectItems
  return deleteTurnstile(locationid, turnstileId)
}

async function getManufacturersApi(entryGateType) {
  let options = {
    isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
      ? localStorage.getItem("X-KC-Realm-ID") ===
        localStorage.getItem("defaultRealmIdSelect")
        ? false
        : true
      : false,
  }
  const res = await smartDeviceAxios.get(
    GET_MANUFACTURERS_API_SERVICE + `entryGateType=${entryGateType}`,
    {
      ...options,
    }
  )
  if (res) {
    return res
  } else {
    return false
  }
}

export {
  turnstileApi,
  createTurnstileApi,
  editTurnstileApi,
  getTurnstileId,
  getTurnstileDetailsByID,
  deleteTurnstile,
  deleteTurnstileApi,
  getLocationById,
  getManufacturersApi,
  MAPPED_DEVICES_MSG,
  getDeleteErrorMessage,
}
